import { render, staticRenderFns } from "./Qna.vue?vue&type=template&id=2bdea163"
import script from "./Qna.vue?vue&type=script&lang=js"
export * from "./Qna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports